import { getRequestContext } from '../context';
import {
    B2B_DOMAIN_DEV,
    B2B_DOMAIN_LOCAL,
    B2B_DOMAIN_PRODUCTION,
    B2B_DOMAIN_SANDBOX,
    B2B_DOMAIN_TEST,
    B2B_URL_LOCAL,
} from './const';

/**
 * Возвращает hostname B2B платформы в зависимости от текущего окружения.
 *
 * @kind helper
 * @returns Hostname для текущего окружения
 * @example
 * getB2BDomainByEnv() // 'b2b.kit.yandex.ru'
 */
export const getB2BDomainByEnv = (): string => {
    const { env, isSandbox } = getRequestContext();

    if (__IS_DEV__) {
        return B2B_DOMAIN_LOCAL;
    }

    if (isSandbox) {
        return B2B_DOMAIN_SANDBOX;
    }

    switch (env) {
        case 'production':
            return B2B_DOMAIN_PRODUCTION;

        case 'prestable':
            return B2B_DOMAIN_TEST;

        case 'development':
            return B2B_DOMAIN_DEV;

        default:
            return B2B_DOMAIN_PRODUCTION;
    }
};

/**
 * Возвращает базовый URL B2B платформы в зависимости от текущего окружения
 * @param path - опциональный путь для добавления к базовому URL (например, '/404')
 * @returns Полный URL для текущего окружения
 *
 * @kind helper
 * @example
 * getB2BUrlByEnv() // 'https://b2b.kit.yandex.ru'
 * getB2BUrlByEnv('/404') // 'https://b2b.kit.yandex.ru/404'
 */
export const getB2BUrlByEnv = (path: string = ''): string => {
    if (__IS_DEV__) {
        return `${B2B_URL_LOCAL}${path}`;
    }

    return `https://${getB2BDomainByEnv()}${path}`;
};
